import { StyleSheet } from 'react-native';
import { pt } from '../common/utils';

export default StyleSheet.create({
    container: {
        backgroundColor: '#E6EEF5',
        flex: 1
    },
    main: {
        flex: 1
    },
    banner: {
        height: pt(213),
        width: pt(375),
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#000'
    },
    banner_video: {
        height: pt(213),
        width: pt(375)
    },
    // banner_img: {
    //   height: pt(213),
    //   width: pt(375),
    // },
    content: {
        height: pt(73),
        width: pt(375),
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        backgroundColor: '#ffffff',
        flexDirection: 'column',
        borderBottomWidth: pt(4),
        borderBottomColor: '#E6EEF5',
        position: 'relative'
    },
    content1: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'flex-start'
    },
    name: {
        height: pt(20),
        // width: pt(160),
        marginTop: pt(13),
        marginLeft: pt(10),
        marginRight: pt(5),
        fontSize: pt(14),
        color: '#000000',
        fontWeight: 'bold',
        fontFamily: 'PingFangSC-Regular',
        textAlign: 'left'
    },
    score: {
        height: pt(14),
        // width: pt(60),
        marginTop: pt(17),
        // marginRight: pt(247),
        fontSize: pt(10),
        color: '#FFAE18',
        fontWeight: 'bold',
        fontFamily: 'PingFangSC-Regular',
        textAlign: 'left'
    },
    detail: {
        height: pt(17),
        width: pt(192),
        marginLeft: pt(12),
        marginRight: pt(171),
        marginBottom: pt(18),
        marginTop: pt(5),
        fontSize: pt(12),
        color: '#252525',
        fontWeight: 'normal',
        fontFamily: 'PingFangSC-Regular',
        textAlign: 'left'
    },
    to_top: {
        position: 'absolute',
        right: pt(5),
        bottom: pt(100)
    },
    btn_tou: {
        position: 'absolute',
        right: 0,
        top: 0,
        height: pt(73),
        paddingLeft: pt(20)
    },
    btn: {
        width: pt(52),
        height: pt(26),
        borderRadius: pt(6),
        backgroundColor: '#E2231A',
        marginTop: pt(20),
        marginRight: pt(10),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    btn_text: {
        color: '#ffffff',
        fontSize: pt(13)
    },
    foot: {
        width: pt(375),
        // height: pt(900),
        backgroundColor: '#fff'
    },
    title: {
        width: pt(100),
        height: pt(24),
        fontSize: pt(14),
        textAlign: 'left',
        marginTop: pt(10),
        marginLeft: pt(10),
        marginBottom: pt(8),
        fontWeight: 'bold'
    },
    list: {
        height: pt(60),
        width: pt(363),
        flexDirection: 'row',
        marginBottom: pt(23)
    },
    list1: {
        flexDirection: 'column'
    },
    list_img: {
        height: pt(60),
        width: pt(100),
        borderRadius: pt(4),
        marginLeft: pt(12),
        marginRight: pt(11)
    },
    list_time: {
        position: 'absolute',
        top: pt(45),
        left: pt(65),
        color: '#fff',
        fontSize: pt(12),
        backgroundColor: 'transparent'
    },
    list_title: {
        // height: pt(20),
        width: pt(226),
        fontSize: pt(14),
        fontWeight: 'bold',
        textAlign: 'left',
        marginTop: pt(7),
        marginBottom: pt(2),
        flexWrap: 'wrap'
    },
    list_number: {
        textAlign: 'left',
        fontSize: pt(12),
        color: '#666666'

    }
});
